import { LicenseId } from 'src/api/dto/organization/licenseId';

const PricePackageLabels = new Map<LicenseId, string>();
PricePackageLabels.set('FREE', 'Free');
PricePackageLabels.set('BASIS', 'Basis');
PricePackageLabels.set('PREMIUM', 'Premium');

export default PricePackageLabels;
